<template>
    <div class="warehouse-entry-edit por" style="margin-bottom: 50px" v-loading="list.loading">
        <PageHeader title="入库管理订单详情" hidden-breadcrumb>
            <template #back>
                <div @click="back"><Icon type="md-arrow-back" /></div>
            </template>
            <Button slot="action" type="primary" @click="handleExport" :loading="exportLoading">
                {{ exportLoading ? '导出中' : '导出' }}
            </Button>
        </PageHeader>
        <Card title="订单信息" :bordered="false" dis-hover class="ivu-mt">
            <Form :label-width="120" ref="form" :model="form">
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="来源: ">
                            <p>ERP同步导入</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="类型: ">
                            <span style="margin-right: 15px">{{ detail.type === 1 ? '直发订单' : '普通订单' }}</span>
                            <!-- 初始状态且是普通订单则显示变更类型-->
                            <!-- 审核中或直发订单则不显示变更类型；-->
                            <Button v-if="detail.type === 0 && detail.status === 0" type="warning" @click="changeType">
                                变更类型
                            </Button>
                        </FormItem>
                    </Col>
                </Row>
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="出库单号: ">
                            <p>{{ detail.sn }}</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="出库单备注: ">
                            <p class="wbba">{{ detail.outboundOrderRemark || '-' }}</p>
                        </FormItem>
                    </Col>
                </Row>
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="门店名称: ">
                            <p>{{ detail.storeName || '-' }}</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="报货地址: ">
                            <p class="wbba">{{ detail.receiveAddress || '-' }}</p>
                        </FormItem>
                    </Col>
                </Row>
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="仓库: ">
                            <p v-if="detail.warehouseSn">
                                {{ detail.warehouseSn }}
                                <span style="display: inline-block; color: #ddd; padding: 0 7px">|</span>
                                {{ detail.warehouseName }}
                            </p>
                            <p v-else>-</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="仓库类型: ">
                            <p>{{ detail.isTotal ? '总仓' : detail.isTotal == null ? ' -' : '分仓' }}</p>
                        </FormItem>
                    </Col>
                </Row>
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="销售单号: ">
                            <p>{{ detail.salesOrderSn || '-' }}</p>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="销售单备注: ">
                            <p class="wbba">{{ detail.salesOrderRemark || '-' }}</p>
                        </FormItem>
                    </Col>
                </Row>
                <Row class="ivu-pr-8">
                    <Col span="12">
                        <FormItem label="分销采购单号: ">
                            <p>{{ detail.distributionOrderSn || '-' }}</p>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </Card>
        <Card title="商品信息" :bordered="false" dis-hover class="ivu-mt ivu-mb-16">
            <VxeTable
                stripe
                highlight-hover-row
                border
                align="center"
                ref="xTable"
                :data="list.data"
                @cell-click="handleExpand"
                :expand-config="{ lazy: true, loadMethod: getBarcodesData }"
            >
                <VxeTableColumn field="productName" title="商品名称"></VxeTableColumn>
                <VxeTableColumn field="quantity" title="数量" width="150"></VxeTableColumn>
                <VxeTableColumn field="unit" title="单位" width="150"></VxeTableColumn>
                <VxeTableColumn type="expand" title="条码/胎号" width="100">
                    <template v-slot:content="{ row }">
                        <div class="tire-sn-list" v-if="row.tireSnList.length > 0">
                            <div
                                :class="['tire-sn', { 'border-show': row.tireSnList.length > 5 && index < 5 }]"
                                v-for="(item, index) in row.tireSnList"
                                :key="index"
                            >
                                <span class="mr-16">{{ item.barcode }}</span>
                                <span>{{ item.tireNo }}</span>
                            </div>
                        </div>
                        <div class="tac pt-10 pb-10" v-else>暂无条码/胎号数据</div>
                    </template>
                </VxeTableColumn>
            </VxeTable>
            <Alert class="ivu-mt-16 ivu-p-8">
                <slot>
                    <div v-color="'#808695'">
                        <p>总数量：{{ sum }}</p>
                    </div>
                </slot>
            </Alert>
        </Card>

        <FooterToolbar>
            <Button @click="back">返回</Button>
        </FooterToolbar>

        <TypeEdit @getData="getData" ref="typeEdit" />
    </div>
</template>

<script>
import { WareHouseEntryEdit, getBarcodes, exportTyreCode } from '../../../api/warehouse';
import TypeEdit from '../components/TypeEdit';
import { transPathToName, jumpPage } from '@/libs/util';

export default {
    name: 'warehouse-entry-edit',
    components: { TypeEdit },
    data() {
        return {
            exportLoading: false,
            id: this.$route.query.id || null,
            stockOutSn: this.$route.query.stockOutSn || null,
            form: {
                name: '',
            },
            sum: 0,
            list: {
                data: [],
                loading: false,
            },
            detail: {},
        };
    },
    methods: {
        async handleExport() {
            try {
                this.exportLoading = true;
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await exportTyreCode({ stockSn: this.stockOutSn });
                this.exportLoading = false;
                this.$Message.destroy();
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {},
                });
            } catch (error) {
                this.exportLoading = false;
                this.$Message.destroy();
            }
        },
        handleExpand(e) {
            // 确保只展开一行
            let { rowIndex, column } = e;
            let { title } = column;
            if (title !== '胎号') {
                return false;
            }
            this.$refs.xTable.clearRowExpand(); // 关闭全部展开行
            this.$refs.xTable.toggleRowExpand(this.list.data[rowIndex]); // 设置当前行展开
        },
        getBarcodesData(row) {
            let rowData = this.list.data[row.rowIndex];
            this.$refs.xTable.clearRowExpand(); // 关闭全部展开行
            return new Promise((resolve, reject) => {
                getBarcodes({
                    materialId: rowData.materialId,
                    stockOutSn: this.stockOutSn,
                }).then(
                    (res) => {
                        this.$refs.xTable.clearRowExpand(); // 关闭全部展开行
                        if (!res || Object.keys(res).length === 0) {
                            row.row.tireSnList = [];
                        } else {
                            const result = Object.entries(res).map(([key, value]) => ({
                                barcode: key,
                                tireNo: value,
                            }));
                            row.row.tireSnList = result;
                        }
                        resolve();
                    },
                    (err) => {
                        row.row.tireSnList = [];
                        this.$refs.xTable.clearRowExpand(); // 关闭全部展开行
                        reject(err);
                    },
                );
            });
        },
        getData() {
            this.list.loading = true;
            WareHouseEntryEdit(this.id).then(
                (res) => {
                    this.list.loading = false;
                    this.list.data = (res.items || []).map((item) => {
                        this.sum += Number(item.quantity);
                        return {
                            ...item,
                            tireSnList: [],
                            productName: item.productName || '-',
                            unit: item.unit || '-',
                        };
                    });
                    this.list.loading = false;
                    this.detail = res;
                },
                () => {
                    this.list.loading = false;
                },
            );
        },
        back() {
            this.sum = 0;
            window.$basePageStore.closeTab(transPathToName(location.pathname));
            jumpPage({ path: '/sub-vue2/warehouse/entry/list' });
        },
        changeType() {
            this.$refs['typeEdit'].open('EDIT', this.detail);
        },
    },
    mounted() {
        this.getData();
    },
};
</script>

<style lang="less" scoped>
.warehouse-entry-edit {
    .container-title {
        padding: 10px 20px;
        margin: 10px 0 20px;
        border-bottom: 1px solid #ddd;
        font-size: 18px;
    }
}
/deep/ .vxe-table--render-default .vxe-body--expanded-cell {
    padding: 0;
}
.tire-sn-list {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .tire-sn {
        flex: 0 0 20%;
        color: #333333;
        border-right: 1px solid #e8eaec;
        padding: 10px;

        &:nth-child(5n) {
            border-right: 0;
        }
    }
    .border-show {
        border-bottom: 1px solid #e8eaec;
    }
}
</style>
